<template>
    <!-- 倒数第二个脚注信息 -->
    <div class="footer1">
        <footer>
            <el-row class="footer-top contain">
                <!-- <el-col :span="7"><img src="../../assets/img/logo2.png" alt="" /> </el-col> -->
<!--                <el-col :span="12">-->
<!--                    <ul class="first-ul">-->
<!--                        <li>联系我们</li>-->
<!--                        <li>邮箱：kaiyun@creatunion.com</li>-->
<!--                        <li>电话：400-628-1365</li>-->
<!--                        <li>地址：北京市朝阳区十里堡路未来时大厦8层</li>-->
<!--                    </ul>-->
<!--                </el-col>-->
<!--                <el-col :span="6">-->
<!--                    <ul>-->
<!--                        <li @click="aboutUs()">关于我们</li>-->
<!--                        <li @click="aboutUs1()">免责声明</li>-->
<!--                        <li @click="aboutUs2()">隐私策略</li>-->
<!--                        <li @click="opionFun()">意见反馈</li>-->
<!--                    </ul>-->
<!--                </el-col>-->

                <el-col>
                  <el-col :span="16">
                    <li style="font-weight: bold;color: black">联系我们</li>
                  </el-col>
                  <el-col :span="8" style="text-align: right;font-weight: 200;color: black">
                    <span @click="aboutUs()">关于我们</span>
                    <span @click="aboutUs1()">免责声明</span>
                    <span @click="aboutUs2()">隐私策略</span>
                    <span @click="opionFun()">意见反馈</span>
                  </el-col>
                  <el-col>
                    <li>邮箱：changtongyuanapp@163.com</li>
                    <li>电话：01065284055   手机号：13260031040</li>
                  </el-col>
                  <el-col :span="16">
                    <span>地址：北京市朝阳区南郎家园18号楼1911室</span>
                  </el-col>
                  <el-col :span="8" style="text-align: right;">
                    <span>©2019畅通圆公司版权所有 青ICP备19001322号</span>
                  </el-col>
                </el-col>
                <!-- <el-col :span="3">
                    <img src="../../assets/img/erWeiMa.png" alt style="width:108px;height:108px" />
                    <br />
                    <span class="erweima">畅通圆APP ios版</span>
                </el-col>
                <el-col :span="3">
                    <img src="../../assets/img/erWeiMa.png" alt style="width:108px;height:108px" />
                    <br />
                    <span class="erweima">畅通圆APP 安卓版</span>
                </el-col>-->
            </el-row>
            <!-- 意见反馈弹框 -->
            <el-dialog title="意见反馈" :visible.sync="dialogFormVisibleYJFK" class="opionCSS">
                <div class="pathogenesis-add add-edit">
                    <el-form
                        class="demo-form-inline"
                        label-width="90px"
                        ref="opions"
                        :model="opions"
                        :rules="rules"
                    >
                        <el-form-item label="意见反馈" prop="opion">
                            <el-input
                                type="textarea"
                                v-model="opions.opion"
                                  :autosize="{ minRows: 10, maxRows: 14}"
                                placeholder
                                class="opionTextArea"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式" prop="contactUs">
                            <el-input v-model="opions.contactUs" placeholder></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer text-center">
                        <el-button class="btn-center login-button" @click="onSubmit('opions')">确 定</el-button>
                    </div>
                </div>
            </el-dialog>
        </footer>
    </div>
</template>

<script>
export default {
    name: "footer1",
    data() {
        return {
            dialogFormVisibleYJFK:false,
            opions: {
                contactUs: "",
                opion: ""
            },
            rules: {
                opion: [
                    {
                        required: true,
                        message: "请输入意见反馈",
                        trigger: "blur"
                    }
                ],
                contactUs: [
                    {
                        required: true,
                        message: "请输入联系方式",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
     watch: {
        dialogFormVisibleYJFK(val, newVal) {
            let that = this;
            //监视dialog状态（打开、关闭）
            // console.log(val);
            if (val) {
                try {
                    // console.log("重置表单");
                    that.$refs.opions.resetFields(); //重置编辑表单
                } catch (e) {}
            }
        }
    },
    methods: {
        handleSelect() {},
        //关于我们,
        aboutUs() {
            let that = this;
            that.$router.push({
                path: "/aboutDetail"
            });
        },
        //免责声明
        aboutUs1() {
            let that = this;
            that.$router.push({
                path: "/mian"
            });
        },
        //隐私策略
        aboutUs2() {
            let that = this;
            that.$router.push({
                path: "/yi"
            });
        },
        //意见反馈弹框
        opionFun() {
            this.dialogFormVisibleYJFK = true;
        },
        // 意见反馈保存
        onSubmit(formName) {
            let that = this;
            if (!this.isLoginF()) return false;
            that.$refs[formName].validate(async valid => {
                if (!valid) return;
                this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                that.dialogFormVisibleYJFK = false;
                let url = "/feedback/add";
                let params = {
                    feedbackuserId: that.userInfo.id,
                    content: that.opions.opion,
                    feedbackSource: 1,
                    linkType: that.opions.contactUs
                };
                that.$http
                    .post(url, params)
                    .then(res => {
                        if (res.data.code == 200) {
                            for (let k in that.opions) {
                                that.opions[k] = "";
                            }
                            that.$message({
                                message: res.data.msg,
                                type: "success"
                            });
                        } else {
                            that.$message.error(res.data.msg);
                        }
                    })
                    .catch(() => {
                        that.$message.error("网络错误！");
                    });
            });
        }
    },
    created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer1 {
}
.login-button {
    background-color: #f64320;
    border-radius: 2px;
    color: #fff;
    margin: 0px auto 20px;
    border: 1px solid #f64320;
}
footer {
  background-color: #fbfbfb;
  padding: 20px 0;
}
.footer-top .el-col {
    margin: 54px 0px;
}
.first-ul li:nth-child(1) {
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 1.8px;
    color: #333333;
    opacity: 1;
}
.footer-top .el-col {
    font-size: 14px;
    line-height: 30px;
    letter-spacing: 0.3px;
    color: #999999;
    cursor: pointer;
    margin: 0;
}
.erweima {
    color: #999999;
    font-size: 12px;
}
/* .footer-bottom{
  font-size: 14px;
  text-align: center;
	line-height: 32px;
	letter-spacing: 1.4px;
	color: #cccccc;
  height: 32px;
	background-color: #555555;
} */
 .opionTextArea{
 }
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue